import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { useAdminAuthStore } from './store/adminAuth';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
window.addEventListener('admin-session-expired', () => {
    useAdminAuthStore(pinia).clearAuth();
    const route = router.currentRoute.value;
    if (route.meta.requiresAuth) router.replace({ path: '/login', query: { return_to: route.fullPath } });
});
app.use(router);

app.mount('#app');
